import { DocumentItem } from "components/member/home/Documents";
import { ScheduledActionItem } from "components/member/home/ScheduledActions";
import { GetMemberDetailsResponse } from "protogen/member_service_pb";
import { ArrowPathIcon, CalendarDaysIcon } from "@heroicons/react/24/outline";
import { LockIcon, SmartphoneCharging } from "lucide-react";
import { ReactComponent as HeartTopIcon } from "../../icons/Menu/HeartTop.svg";

export const coreDocumentsFromMemberDetails = (
  data: GetMemberDetailsResponse | null,
): DocumentItem[] => {
  const docs = data?.coreDocuments ?? [];
  return docs.map((d) => ({
    title: d.title,
    to: `/documents/${d.documentRef}`,
  }));
};

export const scheduledActionsFromMemberDetails = (
  data: GetMemberDetailsResponse | null,
): ScheduledActionItem[] => {
  const actions = data?.scheduledActions ?? [];
  return actions.map((a) => ({
    title: a.title,
    subtitle: a.isPaused ? "Paused" : a.scheduleSummary || "Scheduled action",
    to: a.conversationRef
      ? `/activity?conversationRef=${encodeURIComponent(a.conversationRef)}`
      : "/activity",
    nextRunSec: Number(a.nextRunSec) || undefined,
  }));
};

export const DIGITAL_ONLY_FEATURES = [
  {
    id: "family-secrets",
    title: "Family Secrets",
    description:
      "How to use family secrets to share sensitive information securely.",
    icon: LockIcon,
    link: "https://app.findfaye.com/documents/80671410-6784-41b9-8b20-c020e095222f",
    openInNewTab: true,
  },
  {
    id: "calendar-setup",
    title: "Calendar Setup",
    description: "Connect your calendars for seamless scheduling.",
    icon: ArrowPathIcon,
    link: "https://app.findfaye.com/documents/0fe2b424-bf75-4551-8e84-8dd850db7508",
    openInNewTab: true,
  },
  {
    id: "household-info",
    title: "Household Info",
    description: "Share household details for less back and forth.",
    icon: HeartTopIcon,
    link: "/forms/complete/c2947631-591e-458d-bc64-5952356e82a7",
    openInNewTab: false,
  },
  {
    id: "magic-calendar",
    title: "Magic Calendar",
    description: "Let Faye automatically manage your family calendar.",
    icon: CalendarDaysIcon,
    link: "https://app.findfaye.com/documents/816364b7-0340-4eeb-84c6-6b97cda7c160",
    openInNewTab: true,
  },
  {
    id: "download-app",
    title: "Download Web App",
    description: "Download the Faye web app for a better mobile experience.",
    icon: SmartphoneCharging,
    link: "https://app.findfaye.com/documents/81849feb-b842-460d-9090-e97e569e4a8d",
    openInNewTab: true,
  },
];

export interface HomeLayoutProps {
  data: GetMemberDetailsResponse | null;
  loading: boolean;
  currentUser: any;
  integrationCount: number;
  integrationsLoading: boolean;
  calendarTwoWaySyncUpsell: boolean;
  showAnimations: boolean;
  isDesktop: boolean;
  isMobile: boolean;
  isSystemAdvisor: boolean;
  isDeactivated: boolean;
  productPrompts: any;
  handleDismissReferralBanner: () => void;
  handleReferralBannerLinkClick: () => void;
  handleDismissFeatureSuggestions: () => void;
  handleDismissLightningBanner: () => void;
  handleLightningBannerClick: () => void;
  handleDismissReviewPrompt: () => void;
  handleDismissInspirationBanner: () => void;
  openReview: boolean;
}
